var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { error } from './utils';
var AuthService = /** @class */ (function () {
    function AuthService(api) {
        var _this = this;
        this.sendUserEmailVerification = function (data) {
            return _this.API.post("/auth/email/verification", data);
        };
        this.verifyEmail = function (email, code) {
            return _this.API.patch("/auth/email/verification/".concat(code), { email: email });
        };
        this.API = api;
    }
    AuthService.prototype.updateUserInfo = function (userInfo) {
        var url = '/users/me';
        return this.API.put(url, userInfo);
    };
    AuthService.prototype.changePassword = function (userPasswordInfo) {
        var url = '/users/me/password';
        return this.API.patch(url, userPasswordInfo, !this.API.IS_DRAFTABLE);
    };
    AuthService.prototype.requestTwoFA = function () {
        var url = '/users/me/enable2fa';
        return this.API.put(url);
    };
    AuthService.prototype.enableTwoFA = function (code) {
        var url = '/users/me/verify2fa';
        return this.API.put(url, code);
    };
    AuthService.prototype.disableTwoFA = function () {
        var url = '/users/me/disable2fa';
        return this.API.put(url);
    };
    AuthService.prototype.removeAccount = function (password) {
        var url = '/users/me/';
        return this.API.delete(url, password);
    };
    AuthService.prototype.removeFacebookAccount = function () {
        var url = '/users/me/fb';
        return this.API.delete(url);
    };
    AuthService.prototype.getUserProfile = function () {
        var url = '/users/me';
        return this.API.get(url);
    };
    AuthService.prototype.getUserGroups = function () {
        var url = '/users/me/groups';
        return this.API.get(url);
    };
    AuthService.prototype.exchangeToken = function (email, password, code) {
        return __awaiter(this, void 0, void 0, function () {
            var ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.API.post('/auth/login', {
                                email: email,
                                password: password,
                                code: code,
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        ex_1 = _a.sent();
                        if (ex_1.status === 202) {
                            return [2 /*return*/, {
                                    require2FA: true,
                                }];
                        }
                        error(ex_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, {}];
                }
            });
        });
    };
    AuthService.prototype.signup = function (email, password) {
        var user = {
            email: email,
            password: password,
        };
        return this.API.post('/auth/signup', user);
    };
    AuthService.prototype.sendResetEmail = function (_a) {
        var _b = _a.appId, appId = _b === void 0 ? null : _b, email = _a.email;
        var obj = {
            email: email,
        };
        return this.API.post('/auth/resetpassword', obj, { appId: appId });
    };
    AuthService.prototype.savePassword = function (password, token, name, last_name) {
        var obj = name || last_name
            ? {
                password: password,
                name: name,
                meta: { last_name: last_name },
            }
            : {
                password: password,
            };
        return this.API.post("/auth/resetpassword/".concat(token), obj);
    };
    AuthService.prototype.performBulkResetPassword = function (appId, emails) {
        var obj = {
            emails: emails,
        };
        return this.API.post('/auth/bulkresetpassword ', obj, { appId: appId });
    };
    AuthService.prototype.getAppUserDetails = function (appId, token) {
        return this.API.post("/auth/appusername/".concat(token), {}, { appId: appId });
    };
    return AuthService;
}());
export { AuthService };
